import { __assign } from "tslib";
export var LABEL_COLOR = '#061632';
export var DEF_HEAT_COLOR = ['#004EB2', '#89CFFC'];
export var moduleExtract = function (m) { return (m.default ? m.default : m); };
/**
 * 画(椭)圆
 * @param {*} center 中心点坐标
 * @param {*} radius 半径
 * @param {*} number 多少个点画成一个圆
 * @param {*} a 椭圆横轴
 * @param {*} b 椭圆纵轴
 */
function drawCircle(center, radius, number, a, b) {
    if (a === void 0) { a = 1; }
    if (b === void 0) { b = 1; }
    var points = [];
    for (var i = 0; i < number; i++) {
        var angle = Math.PI * 2 / number * i;
        var x = radius * a * Math.cos(angle);
        var y = radius * b * Math.sin(angle);
        points.push([center.x + x, center.y + y]);
    }
    return points;
}
/**
 * 拼接一个 geo feature
 */
export var featureFactory = function (name, properties, center, radius, number) {
    if (radius === void 0) { radius = 5; }
    if (number === void 0) { number = 10; }
    var coordinate = drawCircle(center, radius, number, 1, 0.75);
    return {
        id: name,
        type: 'Feature',
        properties: __assign({ name: name, fullname: name }, properties),
        geometry: {
            type: 'Polygon',
            coordinates: [coordinate]
        }
    };
};
export function bindAutoHideLabel(chart) {
    var TIMER = '_patsnap_map_auto_hide_label_timmer';
    chart[TIMER] = null;
    function getActLabelCall(bol) {
        return function () { return chart.setOption({
            geo: { label: { show: bol } }
        }, false); };
    }
    chart.on('mouseover', { seriesIndex: 0 }, function (params) {
        if (params.value) {
            clearTimeout(chart[TIMER]);
            getActLabelCall(false)();
        }
    });
    chart.on('mouseout', { seriesIndex: 0 }, function (params) {
        if (params.value) {
            clearTimeout(chart[TIMER]);
            chart[TIMER] = setTimeout(getActLabelCall(true), 2000);
        }
    });
    chart.on('globalout', function () {
        clearTimeout(chart[TIMER]);
        getActLabelCall(true)();
    });
}
//# sourceMappingURL=utils.js.map